import { useState } from 'react';

import { Button } from '../../../../components/Clickables/Buttons/Button';
import { ExternalLink } from '../../../../components/Clickables/ExternalLink/ExternalLink';
import { Container } from '../../../../components/Container/Container';
import { Grid } from '../../../../components/Grid/Grid';
import { Heading } from '../../../../components/Heading/Heading';
import { ChevronDownIcon } from '../../../../components/Icons/ChevronDownIcon';
import { TOP_PERFORMING_WATERS } from '../../../../constants/fishingWaters/topPerformingWaters';
import { useIsTabletScreenWidthOrThinner } from '../../../../helpers/hooks/useScreenWidth';
import { getCountryUrl } from '../../../../helpers/urls';

import { MostPopularFishingLocationCard } from './components/MostPopularFishingLocationCard';

export const OurReccomendedFishingSpots = () => {
  const isTabletScreenWidthOrThinner = useIsTabletScreenWidthOrThinner();
  const [showMore, setShowMore] = useState<boolean>(isTabletScreenWidthOrThinner);

  const pillsShown = isTabletScreenWidthOrThinner ? 3 : 5;

  return (
    <Container className="-px-6 sm:-px-11 md:-px-14">
      <div className="bg-lake-fog p-6 sm:py-8 md:py-12">
        <Heading variant="sm" as="h2" className="mb-4 flex flex-col text-center sm:pb-4">
          Our recommended fishing spots in the United States
        </Heading>

        <div className="flex w-full flex-col sm:rounded-2xl">
          <div data-testid="MostPopularFishingLocationTab">
            <Grid className="mb-4 gap-4 md:mb-8">
              {TOP_PERFORMING_WATERS.map((water, index) => {
                const isHidden = index > pillsShown && !showMore;
                return (
                  <MostPopularFishingLocationCard
                    key={water.locationName}
                    water={water}
                    index={index}
                    isHidden={isHidden}
                  />
                );
              })}
            </Grid>
            <div className="flex justify-center pb-4">
              {!showMore && (
                <Button
                  variant="textPrimary"
                  className="size-[50px]"
                  onClick={() => {
                    setShowMore(true);
                  }}
                >
                  <ChevronDownIcon />
                  <span className="sr-only">Show more</span>
                </Button>
              )}
            </div>

            <div className="flex justify-center">
              <ExternalLink
                className="min-w-32"
                href={getCountryUrl('US', 'United States')}
                variant="buttonSecondary"
              >
                Fishing in the US
              </ExternalLink>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};
